import styled from "styled-components";
import { colors } from "../../../../theme/color";

interface PermissionTitleProps {
  isActive: boolean;
}

export const PermissionMain = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px #eaeaea40;
`;

export const PermissionMainHeader = styled.div`
  padding: 20px;
  width: 96%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaed;
`;

export const PermissionHeaderText = styled.span`
  font-weight: 500;
  font-size: 18px;
  color: ${colors.NAVYBLUE};
`;

export const PermisionBody = styled.div``;

export const PermissionTitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 40%;
  padding: 30px 0px 30px 20px;

  @media screen and (max-width: 430px) {
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    width: 90%;
  }
`;

export const PermissionSubText = styled.div`
  font-size: 14px;
  padding-left: 20px;
  font-weight: 400;
  color: ${colors.NEUTRAL_NEUTRAL};
  width: 80%;
  line-height: 24px;

  @media screen and (max-width: 430px) {
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    width: 90%;
  }
`;

export const PermissionTitle = styled.span<PermissionTitleProps>`
  cursor: pointer;
  font-size: 14px;
  font-weight: ${(props) => (props.isActive ? "500" : "400")};
  color: ${(props) =>
    props.isActive ? colors.NAVYBLUE : colors.NEUTRAL_NEUTRAL};
  // background-color: ${(props) =>
    props.isActive ? "#CECCDE4D" : "transparent"};

  @media screen and (max-width: 430px) {
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    width: 90%;
  }
`;
